/**
 * Camweara Ring Sizer - RockHer Custom Integration
 * (Zero Third-Party Analytics / Zero GTM)
 */
(async () => {
  const ringSvg = `
<svg width="24" height="24" viewBox="189 86 818 1027" preserveAspectRatio="xMinYMid meet" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M723.772 87.1176L791.036 170.602L706.198 170.247L675.757 86.9166L723.772 87.1176ZM651.703 86.8158L682.151 170.146L519.838 169.466L550.976 86.394L651.703 86.8158ZM526.928 86.2933L495.79 169.365L410.952 169.01L478.907 86.0922L526.928 86.2933ZM496.083 191.914L564.816 355.581L413.103 191.567L496.083 191.914ZM681.201 192.69L605.722 368.285C603.872 368.238 602.014 368.216 600.163 368.209C598.299 368.201 596.448 368.206 594.597 368.239L520.592 192.017L681.201 192.69ZM788.697 193.14L697.081 290.529L635.609 355.877L705.709 192.792L788.697 193.14Z"/>
  <path d="M1007.22 706.058C1006.28 931.264 822.28 1113.71 597.055 1112.77C371.823 1111.83 189.364 927.843 190.307 702.637C191.079 518.331 314.768 357.835 491.951 310.015L549.132 371.838C478.674 382.198 413.582 414.601 362.075 465.674C298.318 528.895 262.994 613.159 262.618 702.94C262.242 792.722 296.859 877.272 360.085 941.024C423.304 1004.78 507.575 1040.1 597.364 1040.47C687.154 1040.85 771.711 1006.24 835.469 943.015C899.226 879.794 934.55 795.537 934.925 705.756C935.301 615.974 900.685 531.417 837.459 467.665C786.376 416.163 721.557 383.215 651.188 372.265L708.885 310.923C885.654 360.226 1008 521.752 1007.22 706.058Z"/>
  <g clip-path="url(#clip0_2745_5174)">
    <path d="M868.875 776.864L814.305 884.95C810.7 890.886 804.893 895.154 798.152 896.823C791.412 898.492 784.285 897.427 778.327 893.86L748.996 876.171C754.318 867.742 765.219 848.984 770.566 840.405C771.715 838.422 772.04 836.068 771.47 833.849C770.9 831.63 769.481 829.724 767.52 828.541C765.558 827.358 763.21 826.992 760.981 827.524C758.753 828.055 756.822 829.44 755.605 831.382C750.069 839.891 739.416 858.704 734.035 867.148L699.761 846.471C705.662 836.638 733.626 790.341 740.106 779.573C741.254 777.591 741.579 775.237 741.009 773.017C740.439 770.798 739.021 768.892 737.059 767.709C735.097 766.526 732.749 766.161 730.52 766.692C728.292 767.223 726.361 768.609 725.144 770.55C718.505 781.583 690.87 827.357 684.799 837.448L650.527 816.779L672.097 781.013C673.246 779.031 673.571 776.677 673.001 774.458C672.431 772.238 671.012 770.332 669.051 769.149C667.089 767.966 664.741 767.601 662.512 768.132C660.284 768.663 658.353 770.049 657.136 771.99C651.78 780.607 640.82 799.236 635.566 807.756L601.228 787.041C607.134 777.225 635.085 730.913 641.567 720.154C642.716 718.171 643.04 715.817 642.47 713.598C641.9 711.379 640.482 709.473 638.52 708.29C636.558 707.107 634.21 706.741 631.982 707.273C629.753 707.804 627.822 709.189 626.605 711.131L586.258 778.02L551.997 757.358L573.567 721.591C574.765 719.607 575.125 717.228 574.569 714.978C574.013 712.728 572.585 710.791 570.601 709.593C568.617 708.396 566.238 708.035 563.988 708.592C561.738 709.148 559.801 710.576 558.603 712.56C553.419 721.288 542.154 739.74 537.033 748.326L502.69 727.622C508.614 717.81 536.534 671.479 543.034 660.724C544.231 658.738 544.589 656.359 544.032 654.109C543.474 651.86 542.045 649.924 540.06 648.728C538.075 647.531 535.696 647.173 533.446 647.731C531.196 648.289 529.261 649.717 528.064 651.703L487.728 718.599L453.456 697.93C458.492 689.329 469.89 670.871 475.026 662.164C476.175 660.181 476.499 657.827 475.93 655.608C475.36 653.389 473.941 651.483 471.979 650.3C470.018 649.117 467.669 648.751 465.441 649.283C463.212 649.814 461.282 651.2 460.064 653.141L438.495 688.907L404.231 668.236C410.166 658.431 438.067 612.096 444.569 601.349C445.718 599.367 446.043 597.013 445.473 594.794C444.903 592.574 443.485 590.668 441.523 589.485C439.561 588.302 437.213 587.937 434.984 588.468C432.756 588.999 430.825 590.385 429.608 592.326C422.927 603.333 395.364 649.144 389.261 659.215L359.931 641.527C353.995 637.922 349.728 632.116 348.059 625.375C346.39 618.634 347.456 611.506 351.024 605.548L420.651 509.81C424.256 503.875 430.062 499.606 436.803 497.937C443.544 496.268 450.671 497.333 456.629 500.901L859.42 739.947C865.358 743.551 869.53 750.951 871.199 757.694C872.869 764.436 872.445 770.905 868.875 776.864Z"/>
  </g>
  <defs>
    <clipPath id="clip0_2745_5174">
      <rect width="364.203" height="559.18" fill="white" transform="matrix(0.467654 -0.883911 -0.883911 -0.467654 812.062 910.975)"/>
    </clipPath>
  </defs>
</svg>`;

  const ringSizerButton = document.getElementById("camweara-ring-sizer");
  if (!ringSizerButton) return;

  const iconContainer = ringSizerButton.querySelector(".camweara-icon");
  if (iconContainer) {
    iconContainer.innerHTML = ringSvg;
  }

  let ringSizerIframe = null;
  let shopName = "rockher-jewelry";

  const productTitle = ringSizerButton.dataset.productTitle || "";
  const productType = ringSizerButton.dataset.productType || "";
  const productTags = ringSizerButton.dataset.productTags || "";
  const productCategory = ringSizerButton.dataset.productCategory || "";

  // Validation against S3 Config
  const validateProduct = async () => {
    const s3Url = `https://virginia-bucket-camweara.s3.us-east-1.amazonaws.com/${shopName}/${shopName}_ringsizer.json`;
    const cacheBuster = `?t=${Date.now()}`;

    try {
      const response = await fetch(s3Url + cacheBuster, {
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
      });

      if (!response.ok) return false;

      const sizeCharts = await response.json();
      const condition = sizeCharts.displayCondition;

      if (!condition || !condition.target) return false;

      const target = condition.target;
      const rawValue = (condition.value || "").toLowerCase().trim();
      if (rawValue === "") return false;

      let keywords = rawValue
        .split(",")
        .map((k) => k.trim())
        .filter((k) => k !== "");

      const ringTranslations = [
        "ring", "anillo", "bague", "anello", "anel", "кольцо",
        "戒指", "指輪", "ಉಂಗುರ", "band", "midi"
      ];

      const isRingRelated = keywords.some((k) => ringTranslations.includes(k));
      if (isRingRelated) {
        keywords = [...new Set([...keywords, ...ringTranslations])];
      }

      const checkMatch = (productString) => {
        const lowerStr = (productString || "").toLowerCase();
        return keywords.some((k) => {
          if (/^[a-z]/i.test(k)) {
            const regex = new RegExp(`\\b${k}`, "i");
            return regex.test(lowerStr);
          }
          return lowerStr.includes(k);
        });
      };

      const dataMap = {
        title: productTitle,
        type: productType,
        tag: productTags,
        category: productCategory,
      };

      return checkMatch(dataMap[target]);
    } catch (error) {
      console.error("Camweara validation error:", error);
      return false;
    }
  };

  const isProductValid = await validateProduct();
  if (!isProductValid) return;

  // Reveal the button if product is a ring
  ringSizerButton.style.display = "flex";

  const closeIframe = () => {
    if (!ringSizerIframe) return;
    ringSizerIframe.src = "about:blank";
    setTimeout(() => {
      if (ringSizerIframe) {
        ringSizerIframe.remove();
        ringSizerIframe = null;
      }
    }, 50);
    document.body.classList.remove("overflow");
  };

  // Close message listener
  window.addEventListener("message", (event) => {
    if (event.data === "closeIframe" || event.data === "closeRingSizer") {
      closeIframe();
    }
  });

  // Open modal on click
  ringSizerButton.addEventListener("click", () => {
    if (ringSizerIframe) closeIframe();

    ringSizerIframe = document.createElement("iframe");
    ringSizerIframe.id = "camweara-ring-sizer-iframe";
    ringSizerIframe.className = "camweara-ring-sizer-iframe";
    ringSizerIframe.allow = "camera *; web-share;";

    document.body.appendChild(ringSizerIframe);

    const rawLocale =
      ringSizerButton.dataset.locale ||
      (window.Shopify && window.Shopify.locale) ||
      document.documentElement.lang ||
      "en";

    const shortLang = rawLocale.split("-")[0].toLowerCase();
    ringSizerIframe.src = `https://cdn.camweara.com/ring_sizer/?companyname=${encodeURIComponent(shopName)}&lang=${shortLang}`;
    ringSizerIframe.style.display = "block";
    document.body.classList.add("overflow");
  });
})();